module.exports = __webpack_public_path__ + "static/20-5664637a5d7a86ed96a165f750b29d1e.jpg";